(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('styledAutocomplete', {
            templateUrl: 'app/components/styled-autocomplete/styled-autocomplete.html',
            controller: styledAutocompleteController,
            bindings: {
                labelKey: '@',
                model: '=',
                name: '@',
                required: '<',
                placeholder: '@',
                form: '<',
                searchText: '=',
                querySearch: '&',
                onSelectedItemChange: '&',
                onCreateNewItem: '&',
                notFound: '@',
                createNew: '@',
                spanOption: "@",
                onEditItem: '<',
                readonly: "<",
                onRemoveItem: '<',
                warningMessage: '@',
                showMobileTriggerChevron: '<?'
            }
        });

    /** @ngInject */
    function styledAutocompleteController($q, $uibModal, BrandService, toastr, $translate, $timeout, $element, $localStorage, $window, systemConstants, $scope) {
        var vm = this;
        vm.isImmoContext = $localStorage.defaultStore.immoContext;
        vm.isMobile = $window.innerWidth <= systemConstants.BOOTSTRAP_RESOLUTIONS.MIN_SM;
        vm.mobileSearchText = '';
        vm.mobileResults = [];
        vm.modalVisible = false;
        vm.initialModel = null;
        vm.initialSearchText = "";
        vm.pendingItem = null;
        vm.listItemClicked = false;
        vm.mobileExplicitNone = false;
        vm._confirmJustApplied = false;
        var bottomUpCloseDebounce;

        function sameEntity(referenceEntity, candidateRowEntity) {
            if (!referenceEntity || !candidateRowEntity) {
                return false;
            }
            if (referenceEntity.id != null && candidateRowEntity.id != null) {
                return referenceEntity.id === candidateRowEntity.id;
            }
            return referenceEntity === candidateRowEntity;
        }

        vm.isRowSelected = function(candidateRowEntity) {
            if (vm.listItemClicked && vm.mobileExplicitNone) {
                return false;
            }
            var referenceEntity;
            if (!vm.listItemClicked) {
                referenceEntity = vm.initialModel;
            } else {
                referenceEntity = vm.pendingItem;
            }
            return sameEntity(referenceEntity, candidateRowEntity);
        };

        vm.resetMobileDrawerState = function() {
            vm.mobileSearchText = '';
            vm.mobileResults = [];
            vm.pendingItem = null;
            vm.listItemClicked = false;
            vm.mobileExplicitNone = false;
        };

        vm.mobileSearch = function() {
            var result = vm.querySearch({ searchText: vm.mobileSearchText });
            if (result && typeof result.then === 'function') {
                result.then(function(items) {
                    vm.mobileResults = items || [];
                });
            } else {
                vm.mobileResults = Array.isArray(result) ? result : [];
            }
        };

        vm.onBottomUpOpen = function() {
            vm.initialModel = vm.model ? angular.copy(vm.model) : null;
            vm.initialSearchText = vm.searchText || "";
            vm.listItemClicked = false;
            vm.pendingItem = null;
            vm.mobileExplicitNone = false;
            vm.mobileSearchText = "";
            vm.mobileResults = [];
            $timeout(function() {
                vm.mobileSearch();
            });
        };

        function runBottomUpClose() {
            if (vm._confirmJustApplied) {
                vm._confirmJustApplied = false;
                return;
            }
            vm.searchText = vm.initialSearchText;
            vm.onSelectedItemChange({ item: vm.model });
            vm.resetMobileDrawerState();
        }

        vm.onBottomUpClose = function() {
            if (bottomUpCloseDebounce) {
                $timeout.cancel(bottomUpCloseDebounce);
            }
            bottomUpCloseDebounce = $timeout(function() {
                bottomUpCloseDebounce = null;
                runBottomUpClose();
            }, 0);
        };

        vm.triggerCreateNewItem = function() {
            if (vm.readonly) {
                return;
            }
            var typed =
                vm.mobileSearchText !== undefined && vm.mobileSearchText !== null
                    ? vm.mobileSearchText
                    : vm.searchText !== undefined && vm.searchText !== null
                      ? vm.searchText
                      : "";
            if (Object.prototype.hasOwnProperty.call(vm, "searchText")) {
                vm.searchText = typed;
            }
            if (vm.onCreateNewItem) {
                vm.onCreateNewItem({ searchText: typed });
            }
            $timeout(function() {
                vm.modalVisible = false;
                vm.resetMobileDrawerState();
            }, 0);
        };

        vm.onMobileRowClick = function (item, $event) {
            if ($event) {
                $event.preventDefault();
            }
            if (vm.isRowSelected(item)) {
                vm.listItemClicked = true;
                vm.mobileExplicitNone = true;
                vm.pendingItem = null;
            } else {
                vm.listItemClicked = true;
                vm.mobileExplicitNone = false;
                vm.pendingItem = item;
            }
        };

        vm.confirmSelection = function() {
            if (vm.readonly) {
                return;
            }
            if (vm.listItemClicked && vm.mobileExplicitNone) {
                vm.model = null;
                vm.searchText = "";
            } else if (vm.listItemClicked && vm.pendingItem) {
                vm.model = vm.pendingItem;
                vm.searchText = vm.pendingItem[vm.spanOption];
            } else if (vm.mobileSearchText) {
                vm.model = null;
                vm.searchText = vm.mobileSearchText;
            } else {
                vm.model = vm.initialModel ? angular.copy(vm.initialModel) : null;
                vm.searchText = vm.initialSearchText;
            }
            vm.initialSearchText = vm.searchText;
            vm._confirmJustApplied = true;
            vm.onSelectedItemChange({ item: vm.model });
            vm.resetMobileDrawerState();
        };

        angular.element($window).on('resize', function() {
            $scope.$apply(function() {
                vm.isMobile = $window.innerWidth <= systemConstants.BOOTSTRAP_RESOLUTIONS.MIN_SM;
                if (!vm.isMobile) {
                    vm.modalVisible = false;
                }
            });
        });

        $scope.$on('$destroy', function() {
            angular.element($window).off('resize');
            if (bottomUpCloseDebounce) {
                $timeout.cancel(bottomUpCloseDebounce);
            }
        });

        vm.closeDropdown = function() {
            $timeout(function() {
                vm.searchText = '';

                var input = $element.find('input');
                if (input.length) {
                    input[0].blur();
                }
                var autocomplete = $element.find('md-autocomplete');
                var autocompleteCtrl = autocomplete.controller('mdAutocomplete');
                if (autocompleteCtrl) {
                    autocompleteCtrl.hidden = true;
                }
            });
        };

        vm.editBrand = function (item) {
            if (vm.isMobile) {
                vm.modalVisible = false;
            }
            $uibModal
                .open({
                    templateUrl: "app/admin/brand/modal-brand.html",
                    windowClass: "modal-side-menu",
                    size: "md",
                    controller: "ModalBrandController",
                    controllerAs: "vm",
                    backdrop: "static",
                    resolve: {
                        brand: function () {
                            if (!vm.isMobile) {
                                vm.closeDropdown();
                            }
                            item.editing = true;
                            return angular.copy(item);
                        },
                        onFlyerForm: function () {
                            return true;
                        },
                    },
                })
                .result.then(function (brandData) {
                    if (brandData) {
                        vm.model = brandData;
                        $timeout(function () {
                            vm.searchText = "";
                        });
                        if (vm.isMobile) {
                            vm.mobileSearch();
                        }
                    }
                });
        };

        vm.removeBrand = function(brand) {
            if (!brand || brand.id == null) {
                return $q.resolve();
            }
            return BrandService.removeBrand(brand.id).then(
                function () {
                    toastr.success(
                        $translate.instant(
                            vm.getTranslateKey("brand.messages.success.remove")
                        )
                    );
                    if (vm.isMobile) {
                        vm.mobileSearch();
                    } else {
                        vm.closeDropdown();
                    }
                },
                function () {
                    toastr.warning(
                        $translate.instant(
                            vm.getTranslateKey(
                                "brand.messages.warning.withRegisteredProducts"
                            )
                        )
                    );
                }
            );
        };

        vm.getTranslateKey = function (baseKey) {
            return getTranslateKey(vm.isImmoContext, baseKey);
        };
    }
})();
